/**
 * One confirmation dialog for the whole app (decisions-log V138): a write the server refuses with
 * 409 CONFIRM_REQUIRED asks here and is sent again with `confirm: true` once the user agrees.
 */
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useConfirm } from '../ui/ConfirmDialog';
import type { ConfirmRequest } from '../ui/ConfirmDialog';

const ConfirmContext = createContext<(request: ConfirmRequest) => void>(() => undefined);

export function ConfirmProvider({ children }: { readonly children: ReactNode }) {
  const confirm = useConfirm();
  return (
    <ConfirmContext.Provider value={confirm.ask}>
      {children}
      {confirm.dialog}
    </ConfirmContext.Provider>
  );
}

export const useAskConfirm = (): ((request: ConfirmRequest) => void) => useContext(ConfirmContext);
